import React, { useEffect, createElement } from 'react';
interface FormPlaceholderProps {
  title?: string;
  description?: string;
  fields?: string[];
}
const JOTFORM_ID = '261583799620065';
export function FormPlaceholder({
  title,
  description
}: FormPlaceholderProps) {
  useEffect(() => {
    // Load JotForm's official responsive feedback script once.
    const SCRIPT_SRC = 'https://form.jotform.com/static/feedback2.js';
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <div className="bg-white rounded-xl p-6 md:p-8" data-id="element-52">
      {(title || description) && <div className="mb-4 text-center" data-id="element-53">
          {title && <h3 className="text-xl font-heading font-semibold text-navy mb-1" data-id="element-54">
              {title}
            </h3>}
          {description && <p className="text-navy-600 text-sm" data-id="element-55">{description}</p>}
        </div>}

      <div className="w-full" data-id="element-56">
        <iframe id={`JotFormIFrame-${JOTFORM_ID}`} title={title || 'Contact form'} src={`https://form.jotform.com/${JOTFORM_ID}`} width="100%" height="600" frameBorder={0} scrolling="yes" className="border-0 rounded-lg block h-[850px] md:h-[600px]" data-id="element-57" />
      </div>
    </div>;
}